// extracted by mini-css-extract-plugin
module.exports = {"content":"Content_content__3Yreh","contentIsLoading":"Content_contentIsLoading__TiCaY","errorBoundary":"Content_errorBoundary__2T-13"};